<template>
  <section class="custom-carousel">
    <span class="arrows" @click.stop="prevCarousel">
      <b-icon
        icon="chevron-left"
        size="is-medium"
        :type="isContrast ? 'is-white-dark' : 'is-green-lawn'"
      />
    </span>
    <div
      ref="carousel"
      class="list-carousel"
      @mouseover.once="activeScrollOnMove"
    >
      <a
        v-for="(item, index) in data"
        :key="`link_${index}`"
        :href="sanitizedHtml(item.url)"
        target="_blank"
        rel="noopener external help search"
        :class="`item ${item.round ? 'round' : ''} ${customClass}`"
        @click="checkDrag"
      >
        <slot :index="index" v-bind="item" name="item">
          <b-icon
            :icon="item.icon"
            size="is-large"
            :type="isContrast ? 'is-white-dark' : 'is-green-lawn'"
            class="is-hidden-desktop"
          />
          <b-icon
            :icon="item.icon"
            size="is-big"
            :type="isContrast ? 'is-white-dark' : 'is-green-lawn'"
            class="is-hidden-touch"
          />
          <span class="has-text-weight-bold has-text-color-7">{{
            item.name
          }}</span>
        </slot>
      </a>
    </div>
    <span class="arrows" @click.stop="nextCarousel">
      <b-icon
        icon="chevron-right"
        size="is-medium"
        :type="isContrast ? 'is-white-dark' : 'is-green-lawn'"
      />
    </span>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { sanitizedHtml } from "@/utils/dataManipulation";
export default {
  name: "Carousel",

  props: {
    data: {
      type: Array,
      required: true
    },
    add: {
      type: Number,
      default: 330
    },
    skipItem: {
      type: Number,
      default: 0
    },
    customClass: {
      type: String,
      default: "normal"
    },
    arrowDisable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      sanitizedHtml,
      mouseDown: false,
      drag: false,
      startX: 0,
      scrollLeft: 0
    };
  },

  computed: {
    ...mapGetters({ isContrast: "isContrast" })
  },

  methods: {
    nextItem(inverse = false) {
      const carousel = this.$refs.carousel;
      const position = carousel.getBoundingClientRect();
      const listItens = carousel.querySelectorAll(".item");
      let firstOrLast = listItens?.[0]?.getBoundingClientRect();
      listItens.forEach(element => {
        if (
          element.getBoundingClientRect().x - 10 <
          (inverse ? position.right : position.x)
        ) {
          firstOrLast = element.getBoundingClientRect();
        }
      });
      return this.skipItem
        ? (firstOrLast.width + 30) * this.skipItem
        : this.add;
    },
    nextCarousel() {
      const carousel = this.$refs.carousel;
      const limit = carousel.scrollWidth;
      const actual = carousel.scrollLeft + this.nextItem();
      carousel.scrollTo(limit > actual ? actual : limit, 0);
    },
    prevCarousel() {
      const carousel = this.$refs.carousel;
      const actual = carousel.scrollLeft - this.nextItem(true);
      carousel.scrollTo(actual >= 0 ? actual : 0, 0);
    },
    moveCarousel(event) {
      const carousel = this.$refs.carousel;
      if (event.type === "mousedown") {
        this.drag = false;
        this.mouseDown = true;
        this.startX = event.pageX - carousel.offsetLeft;
        this.scrollLeft = carousel.scrollLeft;
      } else if (["mouseup", "mouseleave"].includes(event.type)) {
        this.mouseDown = false;
      } else if (event.type === "mousemove") {
        this.drag = true;
        event.preventDefault();
        if (this.mouseDown) {
          const x = event.pageX - carousel.offsetLeft;
          const scroll = x - this.startX;
          carousel.scrollLeft = this.scrollLeft - scroll;
        }
      }
    },
    activeScrollOnMove() {
      const carousel = this.$refs.carousel;
      carousel.addEventListener("mouseup", this.moveCarousel, false);
      carousel.addEventListener("mousedown", this.moveCarousel, false);
      carousel.addEventListener("mousemove", this.moveCarousel, false);
      carousel.addEventListener("mouseleave", this.moveCarousel, false);
    },
    checkDrag(event) {
      if (this.drag) event.preventDefault();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.custom-carousel {
  display: flex;
  align-items: center;
  .arrows {
    background-color: $background-color;
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    margin: 5px;
    display: flex;
    align-items: center;
    text-align: center;
    @media screen and (max-width: 769px) {
      display: none;
    }
    &:hover {
      background-color: $color-5;
      .icon {
        color: $color-2 !important;
      }
    }
  }
}
.list-carousel {
  gap: 30px;
  display: flex;
  padding: 10px;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  transition: 1s all ease-out;
  cursor: pointer;
  &::-webkit-scrollbar {
    display: none;
  }
  .item.normal {
    background-color: $background-light;
    height: 165px;
    min-width: 286px;
    @media screen and (max-width: 1440px) {
      min-width: 217px;
    }
    &.round {
      border-radius: 50%;
      height: 165px;
      min-width: 165px;
      justify-content: center;
    }
    @media screen and (max-width: 769px) {
      min-width: 165px;
      height: 90px;
      &.round {
        min-width: 90px;
        height: 90px;
      }
    }
    display: flex;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 5px;
    flex-direction: column;
    text-align: center;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>

<style lang="scss">
@media screen and (max-width: 769px) {
  .item.normal {
    .icon i::before {
      font-size: 36px !important;
    }
  }
}
</style>
